"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconStylePropTypes = exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _mixins = require("../mixins");
var _base = require("../themes/_base");
var _helpers = require("../helpers");
var _excluded = ["width", "padding"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
/** TODO: maybe add margins API as well as the padding API? */

var iconStylePropTypes = _objectSpread(_objectSpread({
  /**
   * Color for the icon. Should be a valid color name from the theme. It will be set to "inherit" if it'is not passed
   */
  color: _propTypes["default"].string,
  /**
   * Size of the icon as a string, should exist in the iconSizes object
   * @default "base"
   */
  size: _propTypes["default"].string,
  /**
   * Number of degrees to rotate the icon by
   */
  rotate: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  /**
   * DEPRECATED: use padding props instead: "p", "pH", "pV", etc.
   */
  padding: _propTypes["default"].oneOf(_base.spaceTypes)
}, _mixins.paddingMixinPropTypes), {}, {
  /** DEPRECATED: Fixed width & height for the icon. Use "w" */
  width: _propTypes["default"].string,
  /**
   * Fixed width & height for the icon. Careful it will include the padding
   */
  w: _propTypes["default"].string,
  /**
   * Title for the svg, used by screen readers
   */
  title: _propTypes["default"].string,
  /**
   * Specifies the background-color to be applied.
   * It should be a valid color token.
   */
  backgroundColor: _propTypes["default"].string,
  /**
   * Specifies the border radius to be applied.
   */
  borderRadius: _propTypes["default"].string
});
exports.iconStylePropTypes = iconStylePropTypes;
var IconWrapperSC = _styledComponents["default"].div.withConfig({
  displayName: "IconWrapper__IconWrapperSC",
  componentId: "sc-17rlh7b-0"
})(["display:inline-flex;font-size:", ";line-height:1;justify-content:center;align-items:center;", ";", ";flex-shrink:0;", ";", ";width:calc( 1em + ", " + ", " );height:calc( 1em + ", " + ", " );svg{shape-rendering:inherit;fill:currentColor;pointer-events:none;}", ";", ";", ";"], function (props) {
  return props.theme.iconSizes[props.size] || props.theme.iconSizes.base;
}, (0, _mixins.colorMixin)("inherit"), (0, _mixins.backgroundMixin)(), _mixins.paddingMixin, _mixins.marginMixin, function (props) {
  return (0, _mixins.getPaddingPropValue)(props, "left") || "0px";
}, function (props) {
  return (0, _mixins.getPaddingPropValue)(props, "right") || "0px";
}, function (props) {
  return (0, _mixins.getPaddingPropValue)(props, "top") || "0px";
}, function (props) {
  return (0, _mixins.getPaddingPropValue)(props, "bottom") || "0px";
}, function (props) {
  return props.rotate && (0, _styledComponents.css)(["transform:rotate(", "deg);"], props.rotate);
}, function (props) {
  var _props$theme$borderRa;
  return props.borderRadius && (0, _styledComponents.css)(["border-radius:", ";"], (_props$theme$borderRa = props.theme.borderRadius[props.borderRadius]) !== null && _props$theme$borderRa !== void 0 ? _props$theme$borderRa : props.theme.borderRadius.base);
}, function (props) {
  return props.w && (0, _styledComponents.css)(["width:", ";height:", ";"], props.w, props.w);
});
IconWrapperSC.displayName = "IconWrapperSC";
var IconWrapper = function IconWrapper(_ref) {
  var width = _ref.width,
    padding = _ref.padding,
    props = _objectWithoutProperties(_ref, _excluded);
  (0, _helpers.useDeprecate)({
    width: width,
    padding: padding
  }, "IconWrapper");
  return /*#__PURE__*/_react["default"].createElement(IconWrapperSC, _extends({
    w: width,
    p: padding
  }, props));
};
IconWrapper.propTypes = iconStylePropTypes;
var _default = IconWrapper;
exports["default"] = _default;